import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import moment from 'moment'
import axios from 'axios'
export default ({
  state: {
    user: null,
    company: null,
    disclaimerAccepted: false,
    disclaimerText: {},
    disclaimerLanguage: 'English',
    languages: [],
    loginTime: null,
    timeout: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setCompany (state, payload) {
      state.company = payload ? payload.toLowerCase() : payload
    },
    setDisclaimerAccepted (state, payload) {
      state.disclaimerAccepted = payload
    },
    setDisclaimerText (state, payload) {
      state.disclaimerText = payload
    },
    setDisclaimerLanguage (state, payload) {
      state.disclaimerLanguage = payload
    },
    setLanguages (state, payload) {
      state.languages = payload
    },
    setLoginTime (state, payload) {
      state.loginTime = payload
    },
    setTimeout (state, payload) {
      state.timeout = payload
    }
  },
  actions: {
    signUserIn ({ commit, dispatch }, payload) {
      const userObj = {
        empID: payload.empID,
        fname: payload.fname,
        sname: payload.sname,
        pin: payload.pin
      }
      commit('setUser', userObj)
      commit('setLoginTime', moment().format('YYYY-MM-DD HH:mm:ss'))
      if (payload.timeout > 0) {
        commit('setTimeout', payload.timeout)
      } else {
        commit('setTimeout', null)
      }
    },
    checkCompany ({ commit }, payload) {
      commit('setCompany', payload)
    },
    logout ({commit}) {
      commit('setUser', null)
      commit('setLoginTime', null)
    },
    fetchDisclaimerAccepted ({commit, getters}) {
      const company = this.getters.company
      const user = this.getters.user
      firebase.database().ref(company + '/disclaimers/' + user.empID).once('value')
        .then(data => {
          const obj = data.val()
          if (obj && obj.accepted) {
            commit('setDisclaimerAccepted', obj.accepted)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    acceptDisclaimer ({commit, getters}) {
      const company = this.getters.company
      const user = this.getters.user
      const obj = {
        accepted: true,
        date: new Date().toISOString()
      }
      firebase.database().ref(company + '/disclaimers/' + user.empID).update(obj)
        .then(data => {
          console.log(data)
          commit('setDisclaimerAccepted', true)
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchDisclaimerText ({commit, getters}) {
      const company = this.getters.company
      if (localStorage.getItem('disclaimerText') !== null && localStorage.getItem('disclaimerText') !== undefined && localStorage.getItem('languages') !== null && localStorage.getItem('languages') !== undefined) {
        commit('setDisclaimerText', JSON.parse(localStorage.getItem('disclaimerText')))
        commit('setLanguages', JSON.parse(localStorage.getItem('languages')))
      }
      firebase.database().ref(company + '/disclaimerText').once('value')
        .then(data => {
          const obj = data.val()
          let languages = []
          for (const language in obj) {
            languages.push(language)
          }
          if (obj) {
            commit('setDisclaimerText', obj) // obj.accepted should always be true if set so we'll be setting disclaimer to false
            localStorage.setItem('disclaimerText', JSON.stringify(obj))
          }
          if (languages) {
            localStorage.setItem('languages', JSON.stringify(languages))
            commit('setLanguages', languages)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    setDisclaimerLanguage ({commit}, payload) {
      commit('setDisclaimerLanguage', payload)
    },
    setLoginTime ({commit}, payload) {
      commit('setLoginTime', payload)
    },
    checkLoginTime ({dispatch, state, rootState}) {
      const timeout = state.timeout + 15
      const loginTime = moment(state.loginTime, 'YYYY-MM-DD HH:mm:ss')
      const diff = moment().diff(loginTime, 'm')
      const diffText = moment().to(loginTime)
      if (timeout && diff >= timeout) {
        console.log('Login timed out')
        const company = this.getters.company
        const user = this.getters.user
        axios.post(rootState.shared.url + `/dms-service/clockoutLongShift.ajax.php`, {emp_id: user.empID, now: moment().format('YYYY-MM-DD HH:mm:ss'), company: company})
          .then(result => {
            console.log(result)
            dispatch('logout')
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        console.log('Logged in ' + diffText + ', login timeouts after ' + timeout + ' minutes.')
      }
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    company (state) {
      return state.company
    },
    disclaimerAccepted (state) {
      return state.disclaimerAccepted
    },
    disclaimerText (state, getters) {
      return state.disclaimerText[getters.disclaimerLanguage]
    },
    disclaimerLanguage (state) {
      return state.disclaimerLanguage
    },
    languages (state) {
      return state.languages
    },
    loginTime (state) {
      return state.loginTime
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/user/index.js